module.exports = require("es-toolkit/compat");